import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Check from '../../Icons/Check';
import Error from '../../Icons/Error';
import SystemNotification from '../../SystemNotification';
import Notification from '../Notification';
export var GenericNotification = function (_a) {
    var id = _a.id, queueName = _a.queueName, messageLocaleKey = _a.messageLocaleKey, isError = _a.isError, _b = _a.cardProps, cardProps = _b === void 0 ? {} : _b;
    var t = useTranslation().t;
    return (React.createElement(Notification, { id: id, queueName: queueName, cardComponent: SystemNotification, cardProps: __assign({ iconComponent: isError ? Error : Check }, cardProps) }, t(messageLocaleKey)));
};
GenericNotification.displayName = 'GenericNotification';
export default GenericNotification;
//# sourceMappingURL=GenericNotification.js.map